<template>
  <div v-show="!isLoaded" class="loading flex align-center justify-center">
    <Icon name="svg-spinners:90-ring-with-bg" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isLoaded?: boolean
}>()
</script>
<style lang="less" scoped>
.loading {
  .absolute-fill();
  .font-xl();
  .text-muted();

  z-index: 1;

  @media print {
    display: none;
  }
}
</style>
